<template>
  <el-dialog
    :visible.sync="addVisible"
    title="制作舱单"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthAdd"
    :before-close="close"
    width="75%"
  >
    <div class="container">
      <el-form
        ref="makeManiFestFormRef"
        class="form-panel"
        label-position="top"
      >
        <el-row :gutter="10" class="content-panel title-fix">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="船公司:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_carrier"
                  :query-method="associate_queryMethod_carrier"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="custAlias"
                  value-prop="csCustId"
                  placeholder=""
                  v-model="searchData.csCustId"
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="14">
                  <el-form-item label="船名/航次:">
                    <el-associate
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      @clear="vesselClear"
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselNameCn"
                      value-prop="vesselName"
                      placeholder=""
                      v-model="searchData.vesselName"
                      size="mini"
                      name="vesselNameEn"
                      @change="onChangevessel"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-associate
                      style="width: 100%"
                      :columns="associate_columns_voyage"
                      :query-method="associate_queryMethod_voyage"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="voyage"
                      value-prop="voyage"
                      placeholder=""
                      v-model="searchData.voyage"
                      size="mini"
                      name="voyage"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-form-item label="提单号:">
                <el-input size="mini" v-model="searchData.mblNo"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单号:">
                <el-input size="mini" v-model="searchData.orderNo"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开航日期从:">
                    <el-date-picker
                      v-model="searchData.createTimeFrom"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开航日期到:">
                    <el-date-picker
                      v-model="searchData.createTimeTo"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      @change="changeCreateTimeTo"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-form-item label=" ">
                <el-button type="primary" size="small" plain @click="queryForm('queryBtn')">查询</el-button>
                <el-button type="primary" size="small" plain @click="resetForm">重置</el-button>
                <el-button type="primary" size="small" plain @click="MakeManiFestToDetail">同步至舱单</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row :gutter="10" class="content-panel title-fix">
          <hot-table
            ref="makeManiFestRef"
            :data-source="makeManiFestTableDataSource"
            :settings="makeManiFestTableSettings"
            col-settings-key="makeManiFest"
          >
            <hot-column
              :has-tip="true"
              data="custBizNo"
              title="客户业务编号"
              width="150"
            >
            </hot-column>

            <hot-column
              :has-tip="true"
              data="orderNo"
              title="订单号"
              width="150"
            >
            </hot-column>
            <hot-column :has-tip="true" data="mblNo" title="提单号" width="150">
            </hot-column>
            <hot-column
              :has-tip="true"
              data="vesselNameEn"
              title="船名"
              width="150"
            >
            </hot-column>
            <hot-column :has-tip="true" data="voyage" title="航次" width="150">
            </hot-column>

            <hot-column
              :has-tip="true"
              data="carrierName"
              title="船公司"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="createTime"
              date-format="YYYY-MM-DD HH:mm:ss"
              title="创建时间"
              width="150"
            >
            </hot-column>
          </hot-table>

          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination
              :current-page="pageConfig.currentPage"
              :layout="pageConfig.layout"
              :page-size="pageConfig.pageSize"
              :page-sizes="pageConfig.pageSizes"
              :total="pageConfig.total"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { queryCarrierInfo, queryVoyageInfo } from "@/api/commonService";
import { selectEbOrderManifest } from "@/api/manifest";
export default {
  name: "makeManifest",
  props: {
    addVisibleFlagInit: Boolean,
  },
  data() {
    return {
       //日期设置
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      addVisible: false,
      // 船公司
      associate_columns_carrier: [
        {
          title: "客商简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      //大船/驳船船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      //航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      searchData: {
        carrierId: "",
        vesselId: "",
        voyage: "",
        orderNo: "",
        mblNo: "",
        createTimeFrom: "",
        createTimeTo: "",
        currentPage: 1,
        pageSize: 10,
      },
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      // 表格设置
      makeManiFestTableSettings: {
        height: 360,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      //表格数据
      makeManiFestTableDataSource: [],
    };
  },
  watch: {
    addVisibleFlagInit() {
      this.$tabIndex.refresh();
      if (this.addVisibleFlagInit === true) this.addVisible = true;
    },
  },
  methods: {
    changeCreateTimeTo() {
      let self = this;
      self.searchData.createTimeTo = new Date(self.searchData.createTimeTo.getTime() + 1000 * 24 * 3600 - 100)
    },
    //关闭
    close() {
      let self = this;
      self.addVisible = false;
      self.$parent.closeMakeManifest();
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          // "CTS_ILPCsCust.carrierId",
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //重置
    resetForm() {
      this.searchData = {
        carrierId: "",
        vesselId: "",
        voyage: "",
        orderNo: "",
        mblNo: "",
        createTimeFrom: "",
        createTimeTo: "",
        currentPage: 1,
        pageSize: 10,
      };
    },
    //查询
    queryForm(type = "pageconfig") {
      let self = this;
      if (type === "queryBtn") self.pageConfig.currentPage = 1;
      self.searchData.currentPage = self.pageConfig.currentPage;
      self.searchData.pageSize = self.pageConfig.pageSize;
      selectEbOrderManifest(this.searchData).then((res) => {
        if (res.success) {
          self.makeManiFestTableDataSource = res.records.records;
          self.pageConfig.total = res.records.totalRecord;
        } else {
          self.$coreMethods.message("error", "查询失败");
        }
      });
    },
    //航次的点击事件
    onChangevessel(value, selectedRows) {
      // console.log(selectedRows)
      // this.searchData.realVesselNameEn = selectedRows.vesselName;
      this.searchData.vesselId = selectedRows.vesselId;
      this.searchData.voyage = selectedRows.voyage;
    },
    vesselClear() {
      this.searchData.realVesselNameEn = "";
      this.searchData.voyage = "";
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryForm();
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryForm();
    },
    MakeManiFestToDetail() {
      let self = this;
      let params = self.$refs.makeManiFestRef.getSelections();
      console.log(this);
      if (params.length !== 1)
        return self.$coreMethods.message("warning", "请勾选一条记录");
      this.close();
      this.$router.push({
        name: "manifestAdd",
        query: {
          ebOrderId: params[0].ebOrderId,
          mainfest: "makeManifest",
        },
      });
    },
  },
  mounted() {
    let _this = this;
    let config = {
        nextKey: {ctrl:false,shift:false,alt:false,key:'enter'},
      }
      _this.$tabIndex.register(_this, config)
  },
  async created() {

  }
};
</script>
<style scoped>
</style>
